module.exports = __webpack_public_path__ + "static/media/Serperior_gaussian2.d49862c4.png";